import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash';

import { searchBuyerInvoice } from '../../../api/adminAccountBuyer'
import { getBuyerInvoiceItems } from '../../../api/buyerInvoiceItem';
import { getAdjustmentNoteItems } from '../../../api/adjustmentNoteItems';
import { getDocItemReplacementLogAndMapByDocIds } from '../../../api/docItemReplacementLog';

import { raiseToast } from '../toast/toast';
import { generateReplacedProducts, getSearchActiveStatus } from '../../../../utils';


export const fetchBuyerInvoice = createAsyncThunk('invoice/getBuyerInvoice', async (params, { dispatch, getState }) => {
    let response
    if (params.dataType === "buyerInvoice" || params.dataType === "accountInvoice"){
        response = await searchBuyerInvoice({...params, statusIds: [1, 6], adminAccountsBuyerFlag: true})
    }
    else if (params.dataType === "creditNotesData"){
        console.log("creditNotesData", {...params, docNoRequired: true, adjustmentTypeIds: [1, 2]})
        response = await getAdjustmentNoteItems({...params, docNoRequired: true, statusIds: [1, 6], adjustmentTypeIds: [1, 2]})
    }
    else{
        response = await getBuyerInvoiceItems({...params, docNoRequired: true, joinRequired: true, adminAccountsBuyerFlag: true})
        const buyerInvoiceIds = response.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerInvoiceId)
        const docReplacementItems = await getDocItemReplacementLogAndMapByDocIds({docIds: buyerInvoiceIds})
        
        response.docReplacementItems = docReplacementItems.data
    }

    if(response.failure){
        dispatch(raiseToast({severity:'error', detail: response.data.error, life: 3000}))
        throw Error()
    }

    const existingData = getState().common
    response.materialUOMs = existingData.materialUOMs

    console.log("fetch response", response)

    if (params.dataType === "buyerInvoice" || params.dataType === "accountInvoice" || params.dataType === "creditNotesData"){
        return response.data
    }else{
        return response
    }
})

export const adminAccountsBuyerSlice = createSlice({
    name: "invoice/getBuyerInvoice",
    initialState: {
        loading: false,
        isInitialLoad: true,
        buyerInvoiceData: [],
        docReplacementItems: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            paginator: false,
            //limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "buyerInvoice",
            searchBy: "all",
            searchText: "",
            statusId: 1,
            dateType: "createdAt",
            docNoRequired: true
        },
        searchOptions: [],
        isSearchVisible: true,
        isSearchActive: true,
        searchConfig: [],
        isSearchPinned: true,
        isSearchByLocked: false
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))
            
            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)
            
            state.isSearchActive = isSearchActive
        },
        updatePaginationParams: (state, action) => {
            state.paginationParams = action.payload
        },
        updateBuyerInvoiceData: (state, action) => {
            state.buyerInvoiceData = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        setTotalBasicAmount: (state, action) => {
            state.totalBasicAmount = action.payload
        },
        setIsSearchPinned: (state, action) => {
            state.isSearchPinned = action.payload
        },
        setIsSearchByLocked: (state, action) => {
            state.isSearchByLocked = action.payload
        },    
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchBuyerInvoice.fulfilled, (state, action) => {
                state.loading = false 
                state.buyerInvoiceData = action.payload.data
                state.paginationParams.totalRecords = action.payload.data.length
                state.paginationParams.pageNo = 0
                state.docReplacementItems = []

                if(action.payload?.docReplacementItems?.length > 0){
                    state.docReplacementItems = action.payload.docReplacementItems

                    const updatedBuyerInvoiceItems = generateReplacedProducts(action.payload.data, action.payload.docReplacementItems, action.payload.materialUOMs)
                    state.buyerInvoiceData = updatedBuyerInvoiceItems
                    state.paginationParams.totalRecords = updatedBuyerInvoiceItems.length
                }

                const parsedState = JSON.parse(JSON.stringify(state))
                if(["buyerInvoice", "accountInvoice"].includes(parsedState.searchParams.dataType)){
                    const totalBasicAmount = _.sumBy(action.payload.data, invoice => parseFloat(invoice.totalAmountBeforeTax));
                    state.totalBasicAmount = totalBasicAmount
                } else {
                    state.totalBasicAmount = 0
                }

                if(state.buyerInvoiceData.length && !state.isSearchPinned){
                    state.isSearchVisible = false
                }
            }
        )
        .addCase(
            fetchBuyerInvoice.pending, (state, action) => {
                console.log("pending")
                state.loading = true 
            }
        )
        .addCase(
            fetchBuyerInvoice.rejected, (state, action) => {
                console.log("rejected")
                state.loading = false
            }
        )
    }
})

export const { updateSearchParams, updateSearchOptions, updatePaginationParams, updateBuyerInvoiceData, setIsSearchVisible, setSearchConfig, setTotalBasicAmount, setIsSearchPinned, setIsSearchByLocked } = adminAccountsBuyerSlice.actions

export default adminAccountsBuyerSlice.reducer